import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import { ModalUtils, Misc } from '@singularsystems/neo-core';

import MyAwardsVM from './MyAwardsVM';
import { observer } from 'mobx-react';
import { PageBlock } from "st-app/Components/Application/PageBlock";
import MyAwardsGrid from './Components/MyAwardsGrid';

import AcceptAwardsView from './AcceptAwardsView';

@observer
export default class MyAwardsView extends Views.ViewBase<MyAwardsVM> {

    constructor(props: unknown) {
        super("My Awards", MyAwardsVM, props);
    }

    public render() {
        return (
            <div className="my-awards">
                <div className="pt-3">
                    <div className="row ms-2">
                        <div className="col">
                            <h2>{this.viewModel.awardModuleConfig.myAwards.header}</h2>
                            <p>
                                {this.viewModel.awardModuleConfig.myAwards.subHeader}
                            </p>
                        </div>
                    </div>
                </div>

                {/* PENDING AWARDS */}
                <Neo.Loader task={this.taskRunner}>
                    <div className="pt-3 page-block-alt">
                        <div>
                            <Neo.Loader task={this.viewModel.myAwardInfoTaskRunner} size="small">
                                <div className="row mb-3 ms-2 align-items-end">
                                    <div className="col-sm-6">
                                        <h2>{this.viewModel.awardModuleConfig.myAwards.pendingAwardsTitle}</h2>
                                        {this.viewModel.hasPendingAwards &&
                                            <p>
                                                {this.viewModel.myAwardsInfoLookup.pendingAwardsMessage}
                                            </p>}
                                    </div>
                                    <div className="col-sm-6">
                                        {this.viewModel.pendingAwardsPageManager.totalPages > 1 && this.viewModel.pendingAwardsPageManager.data.length > 0 &&
                                            <div className="col pager-holder right-tools">
                                                <Neo.PagerControlsBasic pageManager={this.viewModel.pendingAwardsPageManager} noOfButtons={this.viewModel.getPagerNoOfButtons()} />
                                            </div>}
                                    </div>
                                </div>
                            </Neo.Loader>

                            {this.viewModel.hasPendingAwards && !this.viewModel.initialising &&
                                <div>
                                    <MyAwardsGrid
                                        pageManager={this.viewModel.pendingAwardsPageManager}
                                        viewModel={this.viewModel}
                                        showSelection={false}
                                        showAwardDate
                                        config={this.viewModel.awardModuleConfig.myAwards.grid}
                                        showStatusColumn={false} />

                                    <div className="mt-3 right-tools pe-3">
                                        <Neo.Button variant="primary" onClick={() => this.navigation.navigateToView(AcceptAwardsView)}>View pending awards</Neo.Button>
                                    </div>
                                </div>}

                            {!this.viewModel.hasPendingAwards && !this.viewModel.initialising && !this.viewModel.pendingAwardsPageManager.taskRunner.isBusy &&
                                <Neo.Alert variant="info">
                                    <p>
                                        You have no pending awards.
                                    </p>
                                </Neo.Alert>}

                            {/* <div className="footer-banner header-main-background">
                                <div className="message-holder">
                                    <div className="message">The exchange rate of the grant date was used for calculations:</div>
                                    {this.viewModel.ratesCurrentlyUsed.map(rate =>
                                        <div className="message" key={rate.entityIdentifier}>
                                            - {DateUtils.format(rate.rateDate, "dd/MM/yy")} - {NumberUtils.format(1 / rate.rate, "#,##0.######")} {rate.fromCurrencyCode} <strong>=</strong> 1 {rate.toCurrencyCode}
                                        </div>)}
                                </div>
                            </div> */}
                        </div>
                    </div>
                </Neo.Loader>

                {/* GAP */}
                <PageBlock className="pt-3" />

                {/* AWARDS RESPONSES */}
                <Neo.Loader task={this.taskRunner}>
                    <div className="pt-3 page-block-alt">
                        <div className="row ms-2">
                            <div className="col-sm-6">
                                <h2>{this.viewModel.awardModuleConfig.myAwards.awardResponsesHeader}</h2>
                                {this.viewModel.hasAcceptedAwards &&
                                    <p>
                                        {this.viewModel.awardModuleConfig.myAwards.awardResponsesSubHeader}
                                    </p>}
                            </div>
                            <div className="col-sm-6">
                                {this.viewModel.acceptedAwardsPageManager.totalPages > 1 && this.viewModel.acceptedAwardsPageManager.data.length > 0 &&
                                    <div className="col pager-holder right-tools">
                                        <Neo.PagerControlsBasic pageManager={this.viewModel.acceptedAwardsPageManager} noOfButtons={this.viewModel.getPagerNoOfButtons()} />
                                    </div>}
                            </div>
                        </div>

                        {this.viewModel.hasAcceptedAwards && !this.viewModel.initialising &&
                            <>
                                <MyAwardsGrid
                                    pageManager={this.viewModel.acceptedAwardsPageManager}
                                    viewModel={this.viewModel}
                                    showSelection={false}
                                    showAwardDate
                                    hideCurrentGrossValue={true}
                                    showStatusColumn={true}
                                    undoHandler={async (award) => {
                                        const statusText = award.accepted ? "acceptance" : "decline";

                                        if (await ModalUtils.showYesNo(
                                            `Undo ${statusText}?`,
                                            <div>
                                                <p className="mb-3">
                                                    <i className="me-2 fa fa-check-circle text-success" style={{ fontSize: '1.2em' }} />
                                                    This award is still within the acceptance period.
                                                </p>
                                                <p className="mb-3">
                                                    <i className="me-2 fa fa-question-circle text-warning" style={{ fontSize: '1.2em' }} />
                                                    Are you sure you want to undo your {statusText} of this award?
                                                </p>
                                                <p className="mb-0 text-muted">
                                                    <i className="me-2 fa fa-info-circle" />
                                                    You will be able to make a new selection and this award will be moved back into the pending awards section.
                                                </p>
                                            </div>) === Misc.ModalResult.Yes) {
                                            await this.viewModel.undoAwardResponse(award);
                                        }
                                    }}
                                    config={this.viewModel.awardModuleConfig.myAwards.grid} />

                                <div className="row ms-2 pt-3">
                                    <div className="col">
                                        <p>
                                            <small>{this.viewModel.awardModuleConfig.myAwards.awardResponsesFooter}</small>
                                        </p>
                                    </div>
                                </div>
                            </>}
                        {!this.viewModel.hasAcceptedAwards && !this.viewModel.initialising && !this.viewModel.acceptedAwardsPageManager.taskRunner.isBusy &&
                            <Neo.Alert variant="info">
                                <p>
                                    You have no accepted awards.
                                </p>
                            </Neo.Alert>}
                    </div>
                </Neo.Loader>
            </div>
        );
    }
}
